import React from 'react'

export const Marketplace = React.lazy(() => import('./Marketplace'))
export const MarketplaceDetails = React.lazy(() => import('./Marketplace-details'))
